<template>
	<page>
		<v-row class="mt-4 d-flex items-stretch align-items-end">
			<v-col class="d-flex flex-column">
				<center-form :company="company" style="flex: 1;"/>
			</v-col>
			<v-col class="d-flex flex-column">
				<invitations-card style="flex: 1;"/>
			</v-col>
		</v-row>
		<v-row class="mt-4 d-flex items-stretch align-items-end">
			<v-col class="d-flex flex-column">
				<v-card>
					<v-toolbar dark class="p3" color="#ed217c">
						<v-toolbar-title>
							<h4 class="px-4">Users</h4>
						</v-toolbar-title>
					</v-toolbar>
					<v-data-table
						:items="users"
						:headers="usersTableHeaders"
					>
						<template #item.created_at="{item}">
							{{ new Date(item.created_at).toDateString() }}
						</template>
					</v-data-table>
				</v-card>
			</v-col>
			<v-col v-if="invitations.length" class="d-flex flex-column">
				<v-card class="fill-height">
					<v-toolbar dark class="p3" color="#ed217c">
						<v-toolbar-title>
							<h4 class="px-4">Invitations</h4>
						</v-toolbar-title>
					</v-toolbar>
					<v-data-table
						:items="invitations"
						:headers="invitationsTableHeaders"
					>
						<template #item.created_at="{item}">
							{{ new Date(item.created_at).toDateString() }}
						</template>
						<template #item.actions="{item}">
							<remove-btn @remove="removeInvitaition(item)"/>
						</template>
					</v-data-table>
				</v-card>
			</v-col>
		</v-row>
	</page>
</template>

<script>
import CenterForm from "./CenterForm";
import InvitationsCard from "./InvitationsCard";
import UserModule from "../../store/modules/User.module";
import InvitationModule from "../../store/modules/Invitation.module";

export default {
	name: "CenterManageView",
	components: {
		InvitationsCard,
		CenterForm,
	},
	data () {
		return {
			usersTableHeaders: [
				{
					text: this.$t("generics.name"),
					value: "name",
				},
				{
					text: this.$t("last name"),
					value: "last_name",
				},
				{
					text: this.$t("email"),
					value: "email",
				},
				{
					text: this.$t("created_at"),
					value: "created_at",
				},
				{
					text: this.$t("games_count"),
					value: "games_count",
				},
			],
			invitationsTableHeaders: [
				{
					text: this.$t("user_email"),
					value: "user_email",
				},
				{
					text: this.$t("created_at"),
					value: "created_at",
				},
				{
					text: "",
					value: "actions",
				},
			],
		};
	},
	computed: {
		company () {
			return this.$store.getters.authCompany;
		},
		users () {
			return this.$store.state.UserModule.users;
		},
		invitations () {
			return this.$store.state.InvitationModule.invitations;
		},
	},
	methods:{
		removeInvitaition(item){
			this.$store.dispatch(InvitationModule.types.REMOVE,item);
		}
	},
	created () {
		this.$store.dispatch(UserModule.types.FETCH);
		this.$store.dispatch(InvitationModule.types.FETCH);
	},
};
</script>

<style scoped>

</style>
